import { SignaturePacketType } from '@clearcover/core-app-types';

export const currentPacketIdLocalStorageString = (
  policyId: string,
  draftId: string
) => `currentPacketId-${policyId}-${draftId}`;

/**
 * Used to store the current packet so user can refresh page and still have the packet information to check the status
 * @param policyId
 * @param draftId
 * @param packet
 */
export const storeCurrentPacket = (
  policyId: string,
  draftId: string,
  packet: SignaturePacketType
) => {
  localStorage.setItem(
    currentPacketIdLocalStorageString(policyId, draftId),
    JSON.stringify(packet)
  );
};
export const getStoredCurrentPacket = (
  policyId: string,
  draftId: string
): SignaturePacketType | null => {
  const storedItem = localStorage.getItem(
    currentPacketIdLocalStorageString(policyId, draftId)
  );

  if (storedItem) {
    return JSON.parse(storedItem);
  }
  return null;
};

export const removeCurrentPacketFromStorage = (
  policyId: string,
  draftId: string
) => {
  localStorage.removeItem(currentPacketIdLocalStorageString(policyId, draftId));
};

export const currentSignatureRequestId = (policyId: string, draftId: string) =>
  `currentSignatureRequestId-${policyId}-${draftId}`;

export const storeCurrentSignatureRequestId = (
  policyId: string,
  draftId: string,
  signatureRequestId: string
) => {
  localStorage.setItem(
    currentSignatureRequestId(policyId, draftId),
    signatureRequestId
  );
};

/**
 * Used to store the current signature request id so user can refresh page and still have the signature request id
 * @param policyId
 * @param draftId
 * @returns
 */
export const getStoredCurrentSignatureRequestId = (
  policyId: string,
  draftId: string
): string => {
  const storedItem = localStorage.getItem(
    currentSignatureRequestId(policyId, draftId)
  );

  if (storedItem) {
    return storedItem;
  }
  return '';
};

export const removeCurrentSignatureRequestIdFromStorage = (
  policyId: string,
  draftId: string
) => {
  localStorage.removeItem(currentSignatureRequestId(policyId, draftId));
};
